import React, { useEffect, useState } from "react";
import dayjs from 'dayjs';
import ModalImage from "react-modal-image";
import { formatMoney } from "utils";

function Txn(props) {
  const { data } = props;
  let attachment = data?.get("attachment");
  const isPDF = attachment?.includes(".pdf");
  //TODO : If filename contains invalid characters, then change filename to valid filename
  const isImage = attachment?.match(/\.(jpg|jpeg|png|gif|webp)$/i);

  
  const normalView = () => {
    return (
      <div className="d-flex p-0 justify-content-center align-items-start">
        <div className="col-4 col-md-3 px-0 text-end">
          <i className="fs-xmd-smaller">
            {formatMoney(Math.abs(data.get("amount")))}
          </i>
        </div>
        <div className="col-8 col-md-9 ps-2">
          <div className="d-flex flex-wrap col-12">
            <div className="col-12 text-start">
              <small className="word-break text-wrap">{data.get("detail")}</small>
              <div align="right">
                <small align="right"><i >{dayjs(data.get("date")).format('DD MMM')}</i></small>
              </div>
            </div>
            <div align="left">
              {isImage &&
                <div className="container p-0 " >
                  <ModalImage
                    small={data.get("attachment")}
                    large={data.get("attachment")}
                    hideDownload={true}
                    hideZoom={true}
                    className="ms-0 rounded txnAttachment"
                  />
                </div>
              }
              {isPDF && (<a role="button"
                href={attachment}
                target="_blank"
                className="cursor-pointer">
                <i className="bi bi-file-pdf-fill text-app"
                  size={50} />
              </a>)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <li className="list-group-item bg-transparent ">
      <div className="row">
        {!data.get("cancelled") && normalView()}
      </div>
    </li>
  )
}

export default Txn;
